import styled from 'styled-components';
import { Button } from '@mui/material';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
  gap: 24px;
  background-color: #fff;

  @media (max-width: 768px) {
    padding: 16px;
    gap: 16px;
  }
`;

export const ContentHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const Title = styled.h1`
  font-family: 'Montserrat', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #0a1e3d;
  margin: 0;
`;

export const Subtitle = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #666;
  margin: 0;
`;

export const StatsRow = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
`;

export const StatChip = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  border-radius: 8px;
  background-color: #e8f0fe;
  border: 1px solid #c5d4f5;
  min-width: 120px;
  text-align: center;

  @media (max-width: 768px) {
    min-width: unset;
    padding: 10px 16px;
  }
`;

export const StatLabel = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
  font-weight: 500;
`;

export const StatValue = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #0a1e3d;
`;

export const SectionCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;

  @media (max-width: 768px) {
    padding: 16px;
    gap: 12px;
  }
`;

export const SectionTitle = styled.h2`
  font-family: 'Montserrat', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #0a1e3d;
  margin: 0;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const FormRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const TableCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;

  @media (max-width: 768px) {
    padding: 12px;
  }
`;

export const TableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 1px solid #e0e0e0;
  flex-wrap: wrap;
  gap: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const TableTitle = styled.h3`
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #0a1e3d;
  margin: 0;
`;

export const AreaCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 20px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const AreaCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  background-color: #fff;
  border: 1px solid #e8eef5;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #d4dce8;
  }

  @media (max-width: 768px) {
    padding: 16px;
    gap: 10px;
  }
`;

export const AreaCardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-bottom: 1px solid #e8eef5;
  padding-bottom: 12px;
`;

export const AreaName = styled.h3`
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #0a1e3d;
  margin: 0;
  word-break: break-word;
`;

export const AreaCity = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  color: #666;
  margin: 0;
`;

export const AreaDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const DetailRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const DetailLabel = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-size: 11px;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
`;

export const DetailValue = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  color: #0a1e3d;
  word-break: break-word;
`;

export const TagBadge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-family: 'Montserrat', sans-serif;
  font-size: 11px;
  font-weight: 600;
  background-color: #e8f0fe;
  color: #1a4ab5;
  border: 1px solid #c5d4f5;
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  gap: 12px;
  text-align: center;
  width: 100%;
`;

export const EmptyStateText = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #999;
  margin: 0;

  &:first-child {
    font-size: 16px;
    font-weight: 600;
    color: #0a1e3d;
  }
`;

export const ActionButton = styled(Button)`
  && {
    font-size: 13px;
    padding: 8px 16px;
    text-transform: none;
    font-weight: 600;

    @media (max-width: 768px) {
      padding: 6px 12px;
      font-size: 12px;
    }
  }
`;

export const ContentBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;
